export const siteName = "挣扎吧亚当君";

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "影视资讯", to: "/news" },
  { label: "关于我们", to: "/about" },
];

export const quickEntries = [
  {
    label: "电影",
    desc: "佳片名片与剧情解析",
    to: "/category/movie",
    icon: "ri-film-line",
  },
  {
    label: "电视剧",
    desc: "热播剧集与分集导航",
    to: "/category/tv",
    icon: "ri-tv-2-line",
  },
  {
    label: "热门推荐",
    desc: "口碑高分一键直达",
    to: "/category/movie",
    icon: "ri-fire-line",
  },
  {
    label: "最新资讯",
    desc: "行业动态与深度解读",
    to: "/news",
    icon: "ri-newspaper-line",
  },
];

export const siteIntro =
  "「挣扎吧亚当君」是一个以影视作品介绍与剧情导航为核心的影视文化门户。我们为每一部作品整理清晰的剧情脉络、真实的元信息与多维度的深度解读，帮助你在庞杂的影视世界里，快速找到想看的、读懂看过的。";

export const footerLinks = [
  { label: "关于我们", to: "/about" },
  { label: "隐私政策", to: "/about" },
  { label: "使用说明", to: "/about" },
  { label: "联系我们", to: "/about" },
];